// istanbul ignore file: not testable

import {
  pluginTextColorViewer as pluginTextColor,
  pluginTextHighlightViewer as pluginTextHighlight,
  pluginLineSpacingViewer as pluginLineSpacing,
  pluginEmojiViewer as pluginEmoji,
  pluginSpoilerViewer as pluginSpoiler,
  pluginCodeBlockViewer as pluginCodeBlock,
  pluginIndentViewer as pluginIndent,
  type ViewerPlugin,
} from '@wix/ricos';
import {
  pluginLinkLoadable as pluginLink,
  pluginImageLoadable as pluginImage,
  pluginVideoLoadable as pluginVideo,
  pluginDividerLoadable as pluginDivider,
  pluginFileUploadLoadable as pluginFileUpload,
  pluginVerticalEmbedLoadable as pluginVerticalEmbed,
  pluginGiphyLoadable as pluginGiphy,
  pluginMentionsLoadable as pluginMentions,
  pluginGalleryLoadable as pluginGallery,
  pluginCollapsibleListLoadable as pluginCollapsibleList,
  pluginTableLoadable as pluginTable,
  pluginLinkButtonLoadable as pluginLinkButton,
} from '@wix/ricos/loadable';
import '@wix/ricos/css/plugin-spoiler-viewer.global.css';

export const usePlugins = (): ViewerPlugin[] => {
  return [
    pluginTextColor(),
    pluginTextHighlight(),
    pluginLineSpacing(),
    pluginIndent(),
    pluginLink(),
    pluginImage(),
    pluginVideo(),
    pluginDivider(),
    pluginFileUpload(),
    pluginVerticalEmbed(),
    pluginCodeBlock(),
    pluginGallery(),
    pluginEmoji(),
    pluginSpoiler(),
    pluginGiphy(),
    pluginMentions(),
    pluginCollapsibleList(),
    pluginTable(),
    pluginLinkButton(),
  ];
};
